export const createContactFields = () => {
  return [
    {
      name: 'label',
      label: 'Nama Penerima',
      placeholder: 'Nama',
      type: 'text',
      validation: 'bail|required|max:100,length',
    },
    {
      name: 'phoneNumber',
      label: 'Nomor Whatsapp',
      placeholder: 'No. Whatsapp',
      type: 'text',
      validation: 'bail|required|max:100,length|number',
      prefix: '+62',
    },
  ]
}